import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

const queryKey = 'issue-statuses';

export function useIssueStatuses() {
    return useQuery({
        queryKey: [queryKey],
        queryFn: () => sdClient.getIssueStatuses({}),
        staleTime: Infinity,
        gcTime: Infinity,
    });
}
